import { LabelLangString } from "component/LabelLang/label-lang";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

export default function Quote({ title, desc, imgTitle, translation, animAos }) {
  const quote1 = process.env.PUBLIC_URL + "/image/Quotes1.svg";
  const quote = process.env.PUBLIC_URL + "/image/Quotes.svg";

  const currentLocale = useSelector(({ theme }) => theme.locale);
  const dir = useSelector(({ theme }) => theme.direction);

  return (
    <div
      className="row align-items-center mb-5"
        data-aos={animAos}
        data-aos-duration="1500"
        data-aos-easing="ease-in-sine"
      >
        <div className="col-12 col-lg-1">
          <div className="v-img">
            <img src={imgTitle} alt="vision-message" loading="lazy" />
          </div>
        </div>
        <div className="col-12 col-lg-10">
          <div className="">
            <h3 className="v-title">{title}</h3>
          </div>
          <div className="q-box">
            <img src={quote1} style={{rotate: dir === 'ltr' ? '180deg' : '0deg'}} alt="quote" loading="lazy" />
            <h2>
              {translation !== null && translation !== undefined ? (
                  LabelLangString({
                    id: "value",
                    currentLocale: currentLocale,
                    defaultValue: desc,
                    translations: translation
                  })
                
              ) : (
                <FormattedMessage id="data-not-found" />
              )}
            </h2>
            <img src={quote} style={{rotate: dir === 'ltr' ? '180deg' : '0deg'}} alt="quote" loading="lazy" />
          </div>
        </div>
    </div>
  );
}
